import React from "react";
import { CalendarCheck, Truck, Sparkles } from "lucide-react";
import { useT } from "@/lib/i18n";

const VAN_IMG = `${process.env.REACT_APP_BACKEND_URL}/api/uploads/branded_van.png`;

export default function HowItWorks() {
  const { t } = useT();
  const steps = [
    { icon: CalendarCheck, title: t("how.s1.title"), body: t("how.s1.body") },
    { icon: Truck, title: t("how.s2.title"), body: t("how.s2.body") },
    { icon: Sparkles, title: t("how.s3.title"), body: t("how.s3.body") },
  ];

  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-blue">
              {t("how.tag")}
            </p>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-navy">
              {t("how.title")}
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed max-w-md">
              {t("how.body")}
            </p>

            <div className="mt-8 rounded-3xl overflow-hidden border border-slate-200 shadow-sm">
              <img
                src={VAN_IMG}
                alt="Oxford Cleaners branded delivery van"
                className="w-full h-72 object-cover" loading="lazy" decoding="async" />
            </div>
          </div>

          <ol className="lg:col-span-7 grid gap-5">
            {steps.map((s, i) => (
              <li
                key={s.title}
                data-testid={`step-${i + 1}`}
                className="lift relative rounded-2xl border border-slate-200 bg-white p-7 sm:p-8 group"
              >
                <div className="flex items-start gap-5">
                  <div className="shrink-0 h-14 w-14 rounded-2xl bg-brand-lightblue grid place-items-center text-brand-blue group-hover:bg-brand-blue group-hover:text-white transition-colors">
                    <s.icon className="h-6 w-6" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <span className="text-xs font-bold text-brand-blue tabular-nums">
                        0{i + 1}
                      </span>
                      <span className="h-px flex-1 bg-slate-200" />
                    </div>
                    <h3 className="mt-2 font-display text-xl font-semibold text-brand-navy">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-slate-600 leading-relaxed">
                      {s.body}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
